/* eslint-disable no-nested-ternary */
import { Button, Checkbox, FormControlLabel, Grid, Menu, MenuItem, TextField, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { AddBoxRounded } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import Filter from '../../assets/FilterIcon';
import AddnewDepartmentPopup from './AddNewDepartmentPopup';
import NoEmployeeIcon from '../../assets/NoEmployee';
import EmployeeCardItem from './EmployeeCardItem';
import ZeroState from '../common/ZeroState';
import { searchEmployees } from '../utils/Utils';
import ReactInfiniteScroll from '../common/ReactInfiniteScroll';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
    padding: '6px 16px 6px 16px',
  },
  searchText: {
    width: '100%',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
  },
  boxes: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  avatarStyle: {
    height: '48px',
    width: '48px',
  },
  cardContent: {
    borderRadius: '8px',
    width: '100%',
    position: 'relative',
  },
  enabledBox: {
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    background: '#ECFDF3',
    borderRadius: '4px',
    border: '1px solid #D1FADF',
  },
  enabledText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#027A48',
  },
  disabledBox: {
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    background: '#FEF3F2',
    borderRadius: '4px',
    border: '1px solid #FEE4E2',
  },
  disabledText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#B42318',
  },
  bottom: {
    marginBottom: '-10px',
  },
  editEmployeeText: {
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '138%',
    color: '#667085',
  },
  menuRoot: {
    width: '100%',
    borderRadius: '8px',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
  },
  reAEBox: {
    marginLeft: '8px',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 6px',
    background: '#F2F4F7',
    borderRadius: '4px',
  },
  reAEText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '140%',
    color: '#667085',
  },
  employeeAddIcon: {
    height: '42px',
    width: '42px',
    color: '#622FEE',
    marginLeft: '5px',
    cursor: 'pointer',
  },
  secondaryLastAccessText: {
    fontFamily: 'Montserrat',
    marginTop: '4px',
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '15px',
    color: '#667085',
  },
  featherPlus: {
    width: '30px',
    height: '42px',
    background: '#F2F4F7',
    cursor: 'pointer',
    borderRadius: '8px',
    marginLeft: '10px',
  },
  dealerEmployeeRoleWrapper: {
    width: '148px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dealerEmployeeTagWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ruleEmployeeTagWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function EmployeeCardV2({ refreshData, selectedDep, selectedRole }) {
  const classes = useStyles();

  const employees = useSelector((state) => state.GetEmployeeList.employeelist);
  const dealershipDetails = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const [searchEmpVal, setSearchEmpVal] = useState('');
  const [filterEmpArray, setFilterEmpArray] = useState([]);
  const [filterTEmpArray, setFilterTEmpArray] = useState([]);
  const [openEditForm, setOpenEditForm] = useState(false);
  const [editEmployeeHash, setEditEmployeeHash] = useState(null);
  const [showAddNewDepartment, setShowAddNewDepartment] = useState(false);
  const [checkedFilter, setCheckedFilter] = React.useState([true, false, false]);

  const [lengthEmployee, setLengthEmployee] = useState(20);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const handleClickFilter = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    setFilterEmpArray(employees || []);
    const filteredIArray = searchEmployees(employees, searchEmpVal);
    let temp = employees;
    if (filteredIArray.length > 0) {
      temp = filteredIArray;
    } else {
      setSearchEmpVal('');
    }
    setFilterEmpArray(temp || []);
    setFilterTEmpArray(employees || []);
    setCheckedFilter([true, false, false]);
  }, [employees]);

  useEffect(() => {
    setSearchEmpVal('');
  }, [selectedRole, selectedDep]);

  useEffect(() => {
    setSearchEmpVal('');
  }, [dealershipDetails]);

  const handleSearchEmployee = (e) => {
    const input = e.target.value;
    setSearchEmpVal(input);
    const filteredIArray = searchEmployees(filterTEmpArray, input);
    setFilterEmpArray(filteredIArray);
  };

  const handleFilterChange = (index) => {
    setLengthEmployee(20);
    setSearchEmpVal('');
    const temp = [false, false, false];
    temp[index] = true;
    setCheckedFilter(temp);
    let tempArray = [];
    if (index === 0) {
      tempArray = employees;
    } else if (index === 1) {
      tempArray = employees?.filter((i) => i.enabled);
    } else {
      tempArray = employees?.filter((i) => !i.enabled);
    }
    setFilterEmpArray(tempArray || []);
    setFilterTEmpArray(tempArray || []);
  };

  return (
    <Grid container direction="column">
      <Grid container style={{ margin: '10px 0' }}>
        <Grid item style={{ marginLeft: '10px' }} xs={8}>
          <TextField
            id="searchId"
            name="search"
            required
            autoComplete="off"
            autoSave="off"
            onChange={handleSearchEmployee}
            placeholder="Search Employees"
            value={searchEmpVal}
            InputProps={{
              disableUnderline: true,
              className: classes.searchText,
            }}
            rows={1}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            focusRipple={false}
            disableElevation
            aria-controls="simple-menu"
            aria-haspopup="true"
            className={classes.featherPlus}
            onClick={handleClickFilter}
          >
            <Filter style={{ backgroud: '#D3D3D3' }} />
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={filterAnchorEl}
            keepMounted
            open={Boolean(filterAnchorEl)}
            onClose={() => setFilterAnchorEl(null)}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            style={{
              marginTop: '5.5vh',
            }}
          >
            <MenuItem style={{ padding: '0px' }}>
              <FormControlLabel
                classes={{
                  root: classes.fullWidth,
                }}
                label="All"
                control={<Checkbox value="All" checked={checkedFilter[0]} onChange={() => handleFilterChange(0)} />}
              />
            </MenuItem>
            <MenuItem style={{ padding: '0px' }}>
              <FormControlLabel
                classes={{
                  root: classes.fullWidth,
                }}
                label="Enabled"
                control={
                  <Checkbox
                    value="Enabled"
                    defaultChecked
                    checked={checkedFilter[1]}
                    onChange={() => handleFilterChange(1)}
                  />
                }
              />
            </MenuItem>
            <MenuItem style={{ padding: '0px' }}>
              <FormControlLabel
                classes={{
                  root: classes.fullWidth,
                }}
                label="Disabled"
                control={
                  <Checkbox
                    value="Disabled"
                    defaultChecked
                    checked={checkedFilter[2]}
                    onChange={() => handleFilterChange(2)}
                  />
                }
              />
            </MenuItem>
          </Menu>
        </Grid>
        <Grid item>
          <AddBoxRounded className={classes.employeeAddIcon} onClick={() => setShowAddNewDepartment(true)} />
        </Grid>
      </Grid>
      <Grid xs={12} item>
        <Grid container style={{ marginLeft: '5px' }}>
          {employees?.length ? (
            filterEmpArray.length ? (
              <Grid item xs={12}>
                <ReactInfiniteScroll
                  size={lengthEmployee}
                  data={filterEmpArray}
                  height="350px"
                  renderItem={(emp) => (
                    <Grid item xs={5} style={{ margin: '10px' }} key={emp.hash}>
                      <EmployeeCardItem
                        emp={emp}
                        classes={classes}
                        setOpenEditForm={setOpenEditForm}
                        setEditEmployeeHash={setEditEmployeeHash}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            ) : (
              'No Employees Found'
            )
          ) : (
            <ZeroState Icon={NoEmployeeIcon} text="No users have been added in this rule yet." cardWidth="35vw" />
          )}
        </Grid>
      </Grid>
      {showAddNewDepartment && (
        <AddnewDepartmentPopup
          open
          close={() => {
            setShowAddNewDepartment(false);
            refreshData('employees');
          }}
          add
        />
      )}

      {editEmployeeHash && openEditForm && (
        <AddnewDepartmentPopup
          open
          close={() => {
            setEditEmployeeHash(null);
            setOpenEditForm(false);
            refreshData('employees');
          }}
          add={false}
          hash={editEmployeeHash}
        />
      )}
    </Grid>
  );
}
